import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-drivers-salary-month-list-filters',
	templateUrl: './drivers-salary-month-list-filters.component.html',
	styleUrls: ['./drivers-salary-month-list-filters.component.css'],
})
export class DriversSalaryMonthListFiltersComponent extends FiltersComponent {
	@Input() drivers;
	@Input() driverKinds;
	@Input() status;
	@Input() companies;
	@Input() dietKinds;
	@Input() yesno;
	filters = {
		companies: null,
		driver: null,
		status: null,
		driverKinds: null,
		dietKind: null,
		isLeftToPay: null,
		isConfirm: null,
		month: null,
	};
	parameters;
}
